import { render, staticRenderFns } from "./SelectableTaxonomyTree.vue?vue&type=template&id=392c8dc7&"
import script from "./SelectableTaxonomyTree.vue?vue&type=script&lang=ts&"
export * from "./SelectableTaxonomyTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports